import { TranslationService } from "../../../services/TranslationService";
import { getPriorityLevel } from "../utils/agendaUtils";

const LABEL_KEYS = {
  high: "AgendaPriorityHigh",
  medium: "AgendaPriorityMedium",
  low: "AgendaPriorityLow"
} as const;

/** Priority pill (Alta / Media / Baja). Renders nothing when there is no priority. */
const AgendaPriorityBadge = ({ priority }: { priority: number | null }) => {
  const level = getPriorityLevel(priority);
  if (level === null) {
    return null;
  }
  return (
    <span className={`agenda-badge agenda-badge--priority-${level}`}>
      {TranslationService.getTranslation(LABEL_KEYS[level])}
    </span>
  );
};

export default AgendaPriorityBadge;
